import { useUserById } from '../../user/hooks/useUserById';
import { VerificationStatus } from '../constants/verificationStatus';
import { useUser } from 'utils/hooks/useUser';

export const useVerificationStatus = () => {
  const { id: userId } = useUser();
  const { user, isUserLoading } = useUserById({ userId });

  return {
    isVerified: user?.verificationStatus === VerificationStatus.VERIFIED,
    isVerificationLoading: isUserLoading,
  };
};
